/** Phase 1 reality: the foundation only. */
export const PHASE1_FEATURE_FLAGS = Object.freeze({
    customerManagement: false,
    customerSyncWork4All: false,
    documentEditor: false,
    wordImport: false,
    assetUpload: false,
    pdfExport: false,
    shareLinks: false,
    publicCustomerView: false,
    fullTextSearch: false,
    technicalObjects: false,
    measurements: false,
    floorPlans: false,
});
export const DEFAULT_PLATFORM_SETTINGS = {
    platformName: 'OSCOM Technical Documentation Platform',
    defaultRole: 'Reader',
    editorsMayCreateShareLinks: false,
    maxShareLinkLifetimeDays: 90,
    exportRetentionHours: 24,
    confidentialityNotice: 'Vertraulich - nur fuer den vorgesehenen Empfaenger bestimmt.',
};
//# sourceMappingURL=settings.js.map